import React, { ReactElement } from "react";
import Image from "next/image";
import { useRouter } from "next/router";

import { ButtonV2 } from "@/ui-kit";
import { logEvent } from "../../../analytics";
import { Asset } from "components-shared/ContentfulMedia";
import { Hero_c2A } from "../../../../__generated__/graphql";

import styles from "./BannerHero.module.css";

type BannerHeroProps = {
  title: string | null;
  text?: string | null;
  media: Asset;
  c2a?: Hero_c2A | null;
};

export function BannerHero({
  title,
  text,
  media,
  c2a,
}: BannerHeroProps): ReactElement {
  const router = useRouter();

  const onC2APress = () => {
    logEvent("USER_BANNER_CTA");
    if (c2a?.destination?.__typename === "Url") {
      router.push(c2a.destination.url!);
    } else if (c2a?.destination?.__typename === "Page") {
      router.push(c2a.destination.slug ?? "");
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className="container">
        <div className={styles.banner}>
      {media && (
        <Image
          src={media.url ?? ""}
          alt={media.title ?? media.description ?? ""}
          fill
          className={styles.image}
        />
      )}
<div className={styles.content}>
        <h1 className={styles.title}>{title}</h1>
        {text && <p className={styles.text}>{text}</p>}
        {c2a && (
          <div className={styles.ctaButton}>
            <ButtonV2
              variant="secondary"
              title={c2a.title!}
              onPress={onC2APress}
            />
          </div>
        )}
      </div>
        </div>
      </div>
    </div>
  );
}
